{% block sw_cms_block_acris_blog_author_date %}
    <div class="sw-cms-block-acris-blog-author-date">
        <slot name="column"></slot>
    </div>
{% endblock %}
